


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SideMenuItem extends Vue {
  @Prop() private item!: object;

}
